module.exports = __webpack_public_path__ + "static/media/contador-tiempo.6e4587a9.svg";